import React, { Fragment } from "react";
import "components/Project/Home/ActiveProjectHomeInfo/ActiveProjectInfo.css";
import EachActiveProject from "./EachActiveProject";

class ActiveProjectInfo extends React.Component {
 
  renderList(type) {
    if ("Planning" === type) {
      return this.props.projectList.map((elem, index) => (
        <div className="ProjectInfo_MainDiv" key={index}>
          <div className="ProjectInfo_Container">
            <EachActiveProject
              key={index}
              projectSlug={elem.project.slug}
              projectStatus={elem.project_status}
              badge={elem.project.badge}
              type={type}
              projectDate={elem.date_started}
            />
          </div>
        </div>
      ));
    } else if ("Active" === type) {
      return this.props.projectList.map((elem, index) => (
        <div className="ProjectInfo_MainDiv" key={index}>
          <div className="ProjectInfo_Container active-list">
            <EachActiveProject
              key={index}
              projectSlug={elem.project.slug}
              projectStatus={elem.challenge_status}
              badge={elem.project.badge}
              type={type}
              projectDate={elem.date_started}
              adventureId={elem.adventure_id}
              challenge={elem.challenge}
              goalDate={elem.goal_date}
              inviterEmail={elem.invited_by}
              invitationId={elem.invitation_id}
              projectUserId={elem.id}
            />
          </div>
        </div>
      ));
    } else if ("Invitation" === type) {
      return this.props.projectList.map((elem, index) => (
        <div className="ProjectInfo_MainDiv" key={index}>
          <div className="ProjectInfo_Container">
            <EachActiveProject
              key={index}
              projectSlug={elem.project.slug}
              badge={elem.project.badge}
              type={type}
              projectDate={elem.invitation_date}
              inviterName={elem.inviter_user_name}
              inviterEmail={elem.inviter_user_email}
              challenge={elem.challenge}
              invitationId={elem.id}
            />
          </div>
        </div>
      ));
    }
  }

  render() {
    return <Fragment>{this.renderList(this.props.listType)}</Fragment>;
  }
}

export default ActiveProjectInfo;
